import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

async function uploadFile(file) {
  const url = `${URL}v1/files/upload`;
  const formData = new FormData();
  formData.append("file", file, `${new Date().toLocaleDateString()}.csv`);
  return await httpClient.post(url, formData);
}

function getEntityName(entityEndpoint) {
  return `${entityEndpoint.replace(
    "/",
    "-"
  )}-${new Date().toLocaleDateString()}`;
}

async function exportEntity(entityEndpoint, filename = null) {
  const url = `${URL}${entityEndpoint}`;
  const response = await httpClient.get(url, { responseType: "arraybuffer" });

  let fileURL = window.URL.createObjectURL(new Blob([response.data]));
  let fileLink = document.createElement("a");
  fileLink.href = fileURL;

  fileLink.setAttribute(
    "download",
    `${filename ? filename : getEntityName(entityEndpoint)}.csv`
  );
  document.body.appendChild(fileLink);
  fileLink.click();

  window.URL.revokeObjectURL(fileURL);
  fileLink.remove();
}

export default {
  async fetchVolunteeringFields() {
    const url = `${URL}v1/cms/volunteering-fields`;
    return (await httpClient.get(url)).data.data;
  },
  async fetchTasks(query) {
    const url = `${URL}v1/cms/tasks${query}`;
    return (await httpClient.get(url)).data;
  },
  async fetchTaskSessions(taskId, query = "") {
    const url = `${URL}v1/cms/task-sessions/task/${taskId}${query}`;
    return (await httpClient.get(url)).data;
  },
  async fetchTaskSessionAppliedVolunteers(sessionId, query = "") {
    const url = `${URL}v1/cms/task-sessions/${sessionId}/applied${query}`;
    return (await httpClient.get(url)).data;
  },
  async deleteTaskSession(sessionId) {
    const url = `${URL}v1/cms/task-sessions/${sessionId}`;
    return await httpClient.delete(url);
  },
  async completeTaskSession(sessionId, payload) {
    const url = `${URL}v1/cms/task-sessions/${sessionId}/complete`;
    return await httpClient.post(url, payload);
  },
  async importTaskSessionAppliedVolunteers(sessionId, file) {
    const url = `${URL}v1/cms/task-sessions/${sessionId}/complete/import`;
    const fileUrl = await uploadFile(file);
    return await httpClient.post(url, { fileUrl: fileUrl.data.file });
  },
  async exportTaskSessionAppliedVolunteers(sessionId, query) {
    return await exportEntity(
      `v1/cms/task-sessions/${sessionId}/applied/export${query}`,
      "TaskSessionAppliedVolunteers"
    );
  },
  async createTask(task) {
    const url = `${URL}v1/cms/tasks`;
    return await httpClient.post(url, task);
  },
  async updateTask(task) {
    const url = `${URL}v1/cms/tasks/${task.id}`;
    return await httpClient.put(url, task);
  },
  async getTask(taskId, query = "") {
    const url = `${URL}v1/cms/tasks/${taskId}${query}`;
    return (await httpClient.get(url)).data;
  },
  async getTaskVolunteers(taskId, query) {
    const url = `${URL}v1/cms/tasks/${taskId}/volunteers${query}`;
    return (await httpClient.get(url)).data;
  },
  async assignVolunteerToTask(taskId, volunteerId) {
    const url = `${URL}v1/cms/tasks/${taskId}/volunteers`;
    return await httpClient.post(url, { volunteerId });
  },
  async completeTask(taskId, payload) {
    const url = `${URL}v1/cms/tasks/${taskId}/complete`;
    return await httpClient.post(url, payload);
  },
  async removeTask(taskId) {
    const url = `${URL}v1/cms/tasks/${taskId}`;
    return await httpClient.delete(url);
  },
  async publishTask({ taskId, payload, query }) {
    const url = `${URL}v1/cms/tasks/${taskId}/publish${query}`;
    return await httpClient.post(url, payload);
  },
  async fetchTasksAppliedVolunteers(query) {
    const url = `${URL}v1/cms/tasks/volunteers/applied${query}`;
    return (await httpClient.get(url)).data;
  },
  async importTasksAppliedVolunteers(file, taskId) {
    const url = `${URL}v1/cms/tasks/${taskId}/complete/import`;
    const fileUrl = await uploadFile(file);
    return await httpClient.post(url, { fileUrl: fileUrl.data.file });
  },
  async fetchAllAchievementsVolunteers(query) {
    const url = `${URL}v1/cms/thanks-letters${query}`;
    return (await httpClient.get(url)).data;
  },
  async updateAchievement(achievement) {
    const url = `${URL}v1/cms/thanks-letters/${achievement.id}`;
    return await httpClient.put(url, achievement);
  },
  async removeAchievement(achievement) {
    const url = `${URL}v1/cms/thanks-letters/${achievement.id}`;
    return await httpClient.delete(url, achievement);
  },
  async exportAchievement(query) {
    return await exportEntity(
      `v1/cms/thanks-letters/export${query}`,
      "AchievementsVolunteers"
    );
  },
  async importAchievement(file) {
    let excelFile = new FormData();
    excelFile.append("file", file);
    const url = `${URL}v1/cms/thanks-letters/import`;
    return await httpClient.post(url, excelFile);
  },
  async exportTaskSessionsAppliedVolunteers(query = "") {
    const url = `${URL}v1/cms/tasks/volunteers/applied/export${query}`;
    return await httpClient
      .get(url, { responseType: "arraybuffer" })
      .then((res) => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `task-sessions-applied-volunteers-${new Date().toLocaleDateString()}.csv`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
      })
      .catch((error) => console.log(error));
  },
};
